angular.module( 'acme.view.application.programs.modals.scheduleChangedModal', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.modals.scheduleChangedModal.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsModalsScheduleChangedModal = {
        name: 'application.programs.modals.scheduleChangedModal',
        url: '/programs/modals/scheduleChangedModal',
        views: {
          "main": {
            controller: 'ProgramsModalsScheduleChangedModalController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/modals/scheduleChangedModal/scheduleChangedModal.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(programsModalsScheduleChangedModal);
});
